import { FileSpreadsheet } from 'lucide-react';

interface Props {
  visible: boolean;
  hint?: string;
}

/**
 * 화면 전체를 덮는 파일 드롭 타겟 오버레이. useFileDropUpload 훅의 isDragging 와 짝.
 * pointer-events:none 이므로 드롭 자체는 window 리스너가 받는다.
 */
export function FileDropOverlay({ visible, hint }: Props) {
  if (!visible) return null;
  return (
    <div className="pointer-events-none fixed inset-0 z-[60] grid place-items-center bg-foreground/10 backdrop-blur-[2px]">
      <div className="rounded-2xl border-2 border-dashed border-accent bg-surface/95 px-8 py-6 shadow-[var(--shadow)]">
        <div className="flex items-center gap-3">
          <FileSpreadsheet className="size-6 text-accent" />
          <div>
            <div className="text-base font-medium text-foreground">
              여기에 파일을 드롭하여 대화에 추가하세요
            </div>
            <div className="text-xs text-foreground-muted mt-1">
              {hint ?? '.xlsx · .xls · .xlsm'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
